module.exports = __webpack_public_path__ + "img/icon-users.05e92de2.svg";